export class ContratoPropietarioDto{
    public idPropietario: number = 0
}